import { Outlet, useOutletContext, useParams } from 'react-router-dom'

import { observer } from 'mobx-react'

import type { Back } from 'modules/core/components/Card/types'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import type { RouteContextParams } from 'modules/reports/lib/RouterContextParams'
import dashboards from 'modules/reports/store/collections/dashboards'

const DashboardRootPage = () => {
  const { navigation } = useNavigation()

  const { dashboard_id } = useParams()

  const { loading } = useOutletContext<RouteContextParams>()
  const dashboardId = Number(dashboard_id)

  const dashboard = dashboards.get(dashboardId)

  const back: Back = {
    href: navigation.reports.dashboards.dashboardId.list.fullPath({ dashboard_id: dashboardId }),
    label: i18n.t('common.back'),
  }

  return (
    <Outlet
      context={{
        dashboard,
        back,
        loading,
      }}
    />
  )
}

export default observer(DashboardRootPage)
